import React from 'react';
import { MultiSelectDropDownList } from '@trucktrax/trucktrax-common';
import { ProductLine } from '@trucktrax/trucktrax-ts-common';
import { INCOMING_TICKET_PRODUCT_LINES } from '../../../constants/appConstants';
import styles from './IncomingProductLineFilter.module.scss';

// Abbreviated to keep the filter narrow in the ticket panel header.
const PRODUCT_LINE_ABBREVIATIONS: Partial<Record<ProductLine, string>> = {
  [ProductLine.Aggregates]: 'Agg',
  [ProductLine.Cement]: 'Cem',
  [ProductLine.ReadyMix]: 'RM',
};

const items = INCOMING_TICKET_PRODUCT_LINES.map(productLine => ({
  key: productLine,
  label: PRODUCT_LINE_ABBREVIATIONS[productLine] ?? productLine,
}));

export interface IncomingProductLineFilterProps {
  /** The unchecked product lines — the form they are saved in. */
  deselectedProductLines: ProductLine[];
  onChange: (deselectedProductLines: ProductLine[]) => void;
}

/**
 * DEV-5225: the IM ticket panel's Product Line filter. Unchecking every option applies no
 * filter, so the empty dropdown reads "All Product Lines".
 */
export default function IncomingProductLineFilter({
  deselectedProductLines,
  onChange,
}: IncomingProductLineFilterProps) {
  const selected = items.filter(item => !deselectedProductLines.includes(item.key));

  const onUpdateSelected = ({ value }: { value: { key: string | number }[] }) => {
    const checked = value.map(item => item.key);
    onChange(INCOMING_TICKET_PRODUCT_LINES.filter(productLine => !checked.includes(productLine)));
  };

  return (
    <div className={styles.productLineFilter} data-test="incoming-product-line-filter">
      <MultiSelectDropDownList
        items={items}
        initialSelected={selected}
        updateSelected={onUpdateSelected}
        placeholder="All Product Lines"
        lockMessage=""
        showTooltip
      />
    </div>
  );
}
